// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__BPCjk","list":"BalanceDue_list__2czsV","listRow":"BalanceDue_listRow__3NnYS","total":"BalanceDue_total__1rP0p"};